import ScrollHint from 'scroll-hint';

// 横スクロール要素を初期表示時に左右中央へスクロールさせる
const centerScroll = (el) => {
  el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
};

// 要素内の画像がすべて読み込まれてから中央化する（幅が確定してから計算するため）
// 中央化が終わったら onCentered を呼ぶ
const centerWhenImagesReady = (el, onCentered) => {
  const finish = () => {
    centerScroll(el);
    if (onCentered) onCentered();
  };
  const imgs = el.querySelectorAll('img');
  if (!imgs.length) {
    finish();
    return;
  }
  let loaded = 0;
  const done = () => {
    loaded += 1;
    if (loaded === imgs.length) finish();
  };
  imgs.forEach((img) => {
    if (img.complete) {
      done();
    } else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  });
};

// 横スクロール要素（.js-scrollHint）にスワイプ／ドラッグのスクロールヒントを表示
const init = () => {
  const targets = document.querySelectorAll('.js-scrollHint');
  if (!targets.length) return;

  // ScrollHint を起動する（scroll イベントを監視し始める）
  const start = () => {
    new ScrollHint('.js-scrollHint', {
      suggestiveShadow: false, // 端のグラデーション影は出さない
      i18n: {
        scrollable: 'スワイプできます',
      },
    });

    // ヒントアイコンは絶対配置で「中身の原点（left:0）」基準のため、
    // 中央化した scrollLeft の分だけ中身と一緒に左へ流れてしまう。
    // 同じ距離だけ translateX で右へ戻し、表示領域の中央に固定する。
    targets.forEach((el) => {
      const wrap = el.querySelector('.scroll-hint-icon-wrap');
      if (wrap) wrap.style.transform = `translateX(${el.scrollLeft}px)`;
    });
  };

  // 先に中央化してから ScrollHint を初期化する。
  // 中央化の scrollLeft 変更は scroll イベントを発火させるため、
  // ScrollHint より前に済ませてイベントを処理しきっておかないと
  // 「ユーザーが操作した」と誤認されてヒントが消えてしまう。
  let remaining = targets.length;
  const onCentered = () => {
    remaining -= 1;
    if (remaining > 0) return;
    // 中央化で発火した scroll イベントが処理されてから初期化する
    requestAnimationFrame(() => requestAnimationFrame(start));
  };

  // 各要素を初期位置で左右中央に
  targets.forEach((el) => centerWhenImagesReady(el, onCentered));
};

export default init;
